export default function PlaceholderPage({ title }) {
  return (
    <div style={{ padding: 32 }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--cp-gray-900)', marginBottom: 8 }}>
        {title}
      </h1>
      <p style={{ fontSize: 14, color: 'var(--cp-gray-500)' }}>Coming soon.</p>
    </div>
  );
}
